import { useEffect, useState } from 'react';
import axios from 'axios';
import { PublicHeader } from '@/components/PublicHeader';
import { PublicFooter } from '@/components/PublicFooter';
import { MarkupText } from '@/components/MarkupText';
import { PUBLIC_CONTAINER } from '@/components/PublicContainer';

const API = process.env.REACT_APP_BACKEND_URL;

// Emergency fallback only if the DB record is unexpectedly missing.
const FALLBACK = { title: 'About Sergeant TAP', intro: '', sections: [], cta_label: '', cta_url: '/' };

export default function AboutPage() {
  const [data, setData] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'About · Sergeant TAP';
    axios.get(`${API}/api/public/site-content/about`)
      .then((r) => setData(r.data))
      .catch(() => setData(FALLBACK));
  }, []);

  if (!data) {
    return (
      <div className="min-h-screen bg-white flex flex-col">
        <PublicHeader />
        <div className="flex-1 flex justify-center py-24"><div className="animate-spin rounded-full h-10 w-10 border-b-2 border-brand" /></div>
        <PublicFooter />
      </div>
    );
  }

  const sections = (data.sections || []).filter((s) => s.visible !== false)
    .sort((a, b) => (a.order || 0) - (b.order || 0));

  return (
    <div className="min-h-screen bg-white flex flex-col" data-testid="about-page">
      <PublicHeader />
      <main className="flex-1">
        <section className={`${PUBLIC_CONTAINER} pt-12 pb-6`}>
          <h1 className="text-4xl sm:text-5xl font-bold text-slate-900 leading-tight" data-testid="about-title">{data.title}</h1>
          {data.intro && <p className="mt-6 text-lg text-slate-600 leading-relaxed" data-testid="about-intro">{data.intro}</p>}
        </section>

        <div className={`${PUBLIC_CONTAINER} pb-16`}>
          {sections.map((sec) => (
            <section key={sec.id} data-testid={`about-section-${sec.id}`} className="border-t border-slate-100 pt-2">
              {sec.type === 'leadership' ? (
                <div className="mt-8">
                  {sec.heading && <h2 className="text-xl sm:text-2xl font-bold text-slate-900 mb-5">{sec.heading}</h2>}
                  <div className="grid sm:grid-cols-2 gap-5">
                    {(sec.entries || []).map((e, i) => (
                      <div key={i} data-testid={`about-leader-${i}`} className="bg-[#fafafa] border border-slate-100 rounded-xl p-5">
                        <p className="font-semibold text-slate-900">{e.name}</p>
                        <p className="text-sm text-brand font-medium">{e.title}</p>
                        {e.bio && <p className="mt-2 text-[15px] text-slate-700 leading-relaxed">{e.bio}</p>}
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <div>
                  {sec.heading && <h2 className="text-xl sm:text-2xl font-bold text-slate-900 mt-10 mb-3">{sec.heading}</h2>}
                  <MarkupText text={sec.body} />
                </div>
              )}
            </section>
          ))}
        </div>
      </main>
      <PublicFooter />
    </div>
  );
}
